import React from 'react';
import moment from 'moment';

import { EventCard } from '../Cards/EventCard';

const ReviewStalls = ({ formikValues, initialValues }) => {
  const { stalls, stallQuestions } = formikValues;

  const initialObj = {};

  initialValues?.stalls.forEach(stall => {
    initialObj[stall.id] = stall;
  });

  stallQuestions.forEach(question => {
    if (!initialValues?.stallQuestions) {
      return (question.updated = '');
    }

    const initialQuestion = initialValues.stallQuestions.find(element => element.id === question.id);
    const questionTitleWasUpdated = initialQuestion ? question.question !== initialQuestion.question : true;
    const questionTypeWasUpdated = initialQuestion ? question.questionType !== initialQuestion.questionType : true;
    const questionRequiredWasUpdated = initialQuestion ? question.required !== initialQuestion.required : true;
    const questionMaxLengthWasUpdated = initialQuestion ? question.maxLength !== initialQuestion.maxLength : true;
    const questionMinLengthWasUpdated = initialQuestion ? question.minLength !== initialQuestion.minLength : true;
    const questionAnswerOptionsWasUpdated = initialQuestion ? question.answerOptions.length !== initialQuestion.answerOptions.length : true;
    const questionAnswerOptionsTextWasUpdated = initialQuestion
      ? question.answerOptions.filter(answerOption => {
          const initialAnswerOption = initialQuestion.answerOptions.find(element => element.id === answerOption.id);

          if (initialAnswerOption && initialAnswerOption.text !== answerOption.text) {
            return true;
          }

          return false;
        })
      : [];

    const updated =
      questionTitleWasUpdated ||
      questionTypeWasUpdated ||
      questionRequiredWasUpdated ||
      questionMaxLengthWasUpdated ||
      questionMinLengthWasUpdated ||
      questionAnswerOptionsWasUpdated ||
      questionAnswerOptionsTextWasUpdated.length > 0
        ? 'highlighted'
        : '';

    question.updated = updated;
  });

  const highlightReservableDates = ({ initialStart, initialEnd, updatedStart, updatedEnd }) => {
    if (!initialValues?.stalls || !initialStart || !initialEnd || !updatedStart || !updatedEnd) {
      return '';
    }
    const startDateWasUpdated = initialStart !== updatedStart;
    const endDateWasUpdated = initialEnd !== updatedEnd;
    return startDateWasUpdated || endDateWasUpdated ? 'highlighted' : '';
  };

  return (
    <EventCard title="Stalls" testId="review-stalls">
      <div className="info-row">
        {stalls.length &&
          stalls.map(stall => {
            const numStalls = stall.stallsForThisRate.length;
            const initialStallobj = initialObj[stall.id];
            const eDates = initialStallobj
              ? {
                  initialStart: initialStallobj.startDate,
                  updatedStart: stall.dateRange.startDate,
                  initialEnd: initialStallobj.endDate,
                  updatedEnd: stall.dateRange.endDate
                }
              : {
                  initialStart: '-',
                  updatedStart: stall.dateRange.startDate,
                  initialEnd: '-',
                  updatedEnd: stall.dateRange.endDate
                };

            const getClassNames = propName => {
              const highlighted = initialStallobj && initialStallobj[propName] !== stall[propName] ? 'highlighted' : '';
              const classes = `info ${highlighted}`;
              return classes;
            };

            return (
              <div className="info-item" key={stall.name}>
                <h3 className={getClassNames('name')}>{stall.name}</h3>
                <div className={getClassNames('minNights')}>Min nights: {stall.minNights}</div>
                <div className={getClassNames('flippingDisabled')}>Stall Flipping: {stall.flippingDisabled ? 'Disabled' : 'Enabled'}</div>
                <div className={`info ${highlightReservableDates(eDates)}`}>
                  {moment(stall.dateRange.startDate).format('MM/DD/YY')} – {moment(stall.dateRange.endDate).format('MM/DD/YY')}
                </div>
                <div className={getClassNames('price')}>
                  {stall.pricing === 'nightly' ? 'Nightly' : 'Flat'} Rate – ${stall.price}
                </div>
                <div className={`info ${initialStallobj && initialStallobj.stalls.length !== numStalls ? 'highlighted' : ''}`}>
                  {numStalls} {`stall${numStalls > 1 ? 's' : ''}`}
                </div>
              </div>
            );
          })}
      </div>
      <div className="info-questions">
        {!!stallQuestions.length && (
          <>
            <h3>Custom Questions</h3>
            {stallQuestions.map(question => {
              return (
                <div className={`info-question-bloc info ${question.updated}`} key={question.id}>
                  <p className="info-question">{question.question}</p>
                  <ul className="info-answers">
                    {question.questionType !== 'openText' &&
                      question.answerOptions.map(option => {
                        return <li key={option.id}>{option.text}</li>;
                      })}
                  </ul>
                </div>
              );
            })}
          </>
        )}
      </div>
    </EventCard>
  );
};

export default ReviewStalls;
